import { registerLocale, setDefaultLocale } from 'react-datepicker';
import enGB from 'date-fns/locale/en-GB';
registerLocale('enGB', enGB);
setDefaultLocale('enGB');
